import React from "react";

// Reusable section wrapper
export function Section({ children, className = "", ...props }) {
  return (
    <section className={`max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-20 md:py-28 ${className}`} {...props}>
      {children}
    </section>
  );
}

export function Eyebrow({ children, color = "#FF8C00" }) {
  return (
    <p
      className="text-xs font-bold uppercase tracking-[0.25em] mb-4 flex items-center gap-2"
      style={{ color }}
    >
      <span className="w-6 h-px" style={{ background: color }} />
      {children}
    </p>
  );
}

export function H1({ children, className = "" }) {
  return (
    <h1
      className={`font-display font-black text-5xl sm:text-6xl md:text-7xl leading-[0.95] tracking-tighter text-white ${className}`}
    >
      {children}
    </h1>
  );
}

export function H2({ children, className = "" }) {
  return (
    <h2
      className={`font-display font-black text-3xl sm:text-4xl md:text-5xl leading-tight tracking-tight text-white ${className}`}
    >
      {children}
    </h2>
  );
}

export function Lead({ children, className = "" }) {
  return (
    <p className={`text-base md:text-lg text-[#A1A1AA] leading-relaxed max-w-2xl ${className}`}>
      {children}
    </p>
  );
}

export function ButtonPrimary({ children, className = "", ...props }) {
  return (
    <button
      className={`inline-flex items-center justify-center gap-2 px-6 py-3.5 rounded-full bg-[#FF8C00] text-[#0A0A0C] font-bold text-sm hover:bg-[#FFA333] hover:shadow-[0_0_30px_rgba(255,140,0,0.5)] transition-all ${className}`}
      {...props}
    >
      {children}
    </button>
  );
}

export function ButtonGhost({ children, className = "", ...props }) {
  return (
    <button
      className={`inline-flex items-center justify-center gap-2 px-6 py-3.5 rounded-full bg-white/5 border border-white/10 text-white font-bold text-sm hover:bg-white/10 hover:border-white/20 transition-all ${className}`}
      {...props}
    >
      {children}
    </button>
  );
}

export function GlassCard({ children, className = "", ...props }) {
  return (
    <div className={`glass rounded-2xl p-6 md:p-8 ${className}`} {...props}>
      {children}
    </div>
  );
}
